module.exports = {
	"config": {
		"siteTitle": "Husam Machlovi | Product Strategy and Design",
		"siteTagline": "Product Design",
		"siteDescr": "Product Strategy & Design",
		"siteAuthor": "Husam Machlovi",
		"siteEmailUrl": "mailto:husam@withpulp.com",
		"siteTwitterUrl": "https://twitter.com/husam_machlovi",
		"siteGithubUrl": "https://github.com/hudat",
		"siteInstagramUrl": "https://www.instagram.com/husam_machlovi/",
		"siteLinkedinUrl": "https://www.linkedin.com/in/husammachlovi",
		"siteTelegramUrl": "#",
		"siteRssUrl": "#",
		"siteVkUrl": "#",
		"linkPrefix": "/",
		"gaCode": "UA-41596036-2"
	},
	"relativePath": "",
	"pages": [
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "",
				"stem": "_template",
				"path": "_template.jsx"
			},
			"requirePath": "_template.jsx",
			"templatePath": "//",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "404.md",
				"ext": "md",
				"name": "404",
				"extname": ".md",
				"basename": "404.md",
				"dirname": "",
				"stem": "404",
				"path": "404.md"
			},
			"requirePath": "404.md",
			"path": "/404.html",
			"data": {
				"path": "/404.html",
				"layout": "page"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/2016-08-13-the-skinny-suit",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/2016-08-13-the-skinny-suit",
				"stem": "index",
				"path": "articles/2016-08-13-the-skinny-suit/index.md"
			},
			"requirePath": "articles/2016-08-13-the-skinny-suit/index.md",
			"path": "/the-skinny-suit/",
			"data": {
				"title": "The Skinny Suit",
				"date": "2016-08-14T22:40:32.169Z",
				"layout": "post",
				"path": "/the-skinny-suit/",
				"category": "Short Stories",
				"description": "The skinny suit. It was my idea.",
				"readNext": "/a-good-question/"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/2016-10-23-one",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/2016-10-23-one",
				"stem": "index",
				"path": "articles/2016-10-23-one/index.md"
			},
			"requirePath": "articles/2016-10-23-one/index.md",
			"path": "/one/",
			"data": {
				"title": "One",
				"date": "2016-10-23T17:05:07.169Z",
				"layout": "post",
				"path": "/one/",
				"category": "Poetry",
				"description": "Nestled in this polygonal",
				"readNext": "/the-skinny-suit"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/2016-11-12-attention-is-love",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/2016-11-12-attention-is-love",
				"stem": "index",
				"path": "articles/2016-11-12-attention-is-love/index.md"
			},
			"requirePath": "articles/2016-11-12-attention-is-love/index.md",
			"path": "/attention-is-love/",
			"data": {
				"title": "Attention Is Love",
				"date": "2016-11-12T16:17:07.169Z",
				"layout": "post",
				"path": "/attention-is-love/",
				"category": "Thoughts",
				"description": "When we give others attention, we are giving them love.",
				"readNext": "/one"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/2016-11-14-shipping-is-an-act-of-kindness",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/2016-11-14-shipping-is-an-act-of-kindness",
				"stem": "index",
				"path": "articles/2016-11-14-shipping-is-an-act-of-kindness/index.md"
			},
			"requirePath": "articles/2016-11-14-shipping-is-an-act-of-kindness/index.md",
			"path": "/shipping-is-kind/",
			"data": {
				"title": "Shipping Is An Act Of Kindness",
				"date": "2016-11-14T19:16:07.169Z",
				"layout": "post",
				"path": "/shipping-is-kind/",
				"category": "Thoughts",
				"description": "To ship our creative work is to act kindly.",
				"readNext": "/attention-is-love/"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/2016-11-15-on-publishing-our-work",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/2016-11-15-on-publishing-our-work",
				"stem": "index",
				"path": "articles/2016-11-15-on-publishing-our-work/index.md"
			},
			"requirePath": "articles/2016-11-15-on-publishing-our-work/index.md",
			"path": "/on-publishing-our-work/",
			"data": {
				"title": "On Publishing Our Work",
				"date": "2016-11-15T19:16:07.169Z",
				"layout": "post",
				"path": "/on-publishing-our-work/",
				"category": "Thoughts",
				"description": "Publishing our work teaches us to see failure as a part of the process.",
				"readNext": "/shipping-is-kind/"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/2016-11-17-bringing-an-idea-to-life",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/2016-11-17-bringing-an-idea-to-life",
				"stem": "index",
				"path": "articles/2016-11-17-bringing-an-idea-to-life/index.md"
			},
			"requirePath": "articles/2016-11-17-bringing-an-idea-to-life/index.md",
			"path": "/bringing-an-idea-to-life/",
			"data": {
				"title": "Bringing An Idea To Life",
				"date": "2016-11-17T19:16:07.169Z",
				"layout": "post",
				"path": "/bringing-an-idea-to-life/",
				"category": "Thoughts",
				"description": "How do we bring an idea to life? Persistent action.",
				"readNext": "/on-publishing-our-work/"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/2016-11-18-a-new-day",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/2016-11-18-a-new-day",
				"stem": "index",
				"path": "articles/2016-11-18-a-new-day/index.md"
			},
			"requirePath": "articles/2016-11-18-a-new-day/index.md",
			"path": "/a-new-day/",
			"data": {
				"title": "A New Day",
				"date": "2016-11-17T19:16:07.169Z",
				"layout": "post",
				"path": "/a-new-day/",
				"category": "Poetry",
				"description": "Today, I take off my armor of apathy. Today, we are no strangers.",
				"readNext": "/bringing-an-idea-to-life/"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/2016-11-19-courage",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/2016-11-19-courage",
				"stem": "index",
				"path": "articles/2016-11-19-courage/index.md"
			},
			"requirePath": "articles/2016-11-19-courage/index.md",
			"path": "/courage/",
			"data": {
				"title": "Courage",
				"date": "2016-11-19T19:16:07.169Z",
				"layout": "post",
				"path": "/courage/",
				"category": "Poetry",
				"description": "What's courageous to you?",
				"readNext": "/a-new-day/"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/2016-11-23-speak-up",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/2016-11-23-speak-up",
				"stem": "index",
				"path": "articles/2016-11-23-speak-up/index.md"
			},
			"requirePath": "articles/2016-11-23-speak-up/index.md",
			"path": "/speak-up/",
			"data": {
				"title": "Speak Up",
				"date": "2016-11-23T19:16:07.169Z",
				"layout": "post",
				"path": "/speak-up/",
				"category": "Thoughts",
				"description": "Go ahead. Pick up the mic. It's your turn.",
				"readNext": "/courage/"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/2016-11-25-a-good-question",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/2016-11-25-a-good-question",
				"stem": "index",
				"path": "articles/2016-11-25-a-good-question/index.md"
			},
			"requirePath": "articles/2016-11-25-a-good-question/index.md",
			"path": "/a-good-question/",
			"data": {
				"title": "A Good Question",
				"date": "2016-11-25T19:16:07.169Z",
				"layout": "post",
				"path": "/a-good-question/",
				"category": "Thoughts",
				"description": "There are no bad questions. But not every question is a good question.",
				"readNext": "/speak-up/"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/2016-11-26-key-advantages-in-an-ai-world",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/2016-11-26-key-advantages-in-an-ai-world",
				"stem": "index",
				"path": "articles/2016-11-26-key-advantages-in-an-ai-world/index.md"
			},
			"requirePath": "articles/2016-11-26-key-advantages-in-an-ai-world/index.md",
			"path": "/key-advantages-in-an-ai-world/",
			"data": {
				"title": "Key Advantages In An AI World",
				"date": "2016-11-26T19:16:07.169Z",
				"layout": "post",
				"path": "/key-advantages-in-an-ai-world/",
				"category": "Thoughts",
				"description": "AI is here. How do we prepare for it?",
				"readNext": "/a-good-question/"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/2017-02-06-the-path",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/2017-02-06-the-path",
				"stem": "index",
				"path": "articles/2017-02-06-the-path/index.md"
			},
			"requirePath": "articles/2017-02-06-the-path/index.md",
			"path": "/the-path/",
			"data": {
				"title": "The Path",
				"date": "2017-02-06T19:16:07.169Z",
				"layout": "post",
				"path": "/the-path/",
				"category": "Poetry",
				"description": "The Path",
				"readNext": "/key-advantages-in-an-ai-world/"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/2017-04-13-between-stimulus-and-response",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/2017-04-13-between-stimulus-and-response",
				"stem": "index",
				"path": "articles/2017-04-13-between-stimulus-and-response/index.md"
			},
			"requirePath": "articles/2017-04-13-between-stimulus-and-response/index.md",
			"path": "/between-stimulus-and-response/",
			"data": {
				"title": "Between Stimulus and Response",
				"date": "2017-04-13T19:16:07.169Z",
				"layout": "post",
				"path": "/between-stimulus-and-response/",
				"category": "Poetry",
				"description": "Between Stimulus and Response",
				"readNext": "/the-path/"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/2017-05-11-on-being-yourself",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/2017-05-11-on-being-yourself",
				"stem": "index",
				"path": "articles/2017-05-11-on-being-yourself/index.md"
			},
			"requirePath": "articles/2017-05-11-on-being-yourself/index.md",
			"path": "/on-being-yourself/",
			"data": {
				"title": "On Being Yourself",
				"date": "2017-05-11T19:16:07.169Z",
				"layout": "post",
				"path": "/on-being-yourself/",
				"category": "Poetry",
				"description": "On Being Yourself",
				"readNext": "/between-stimulus-and-response/"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/2017-08-16-cant-tell-you-why",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/2017-08-16-cant-tell-you-why",
				"stem": "index",
				"path": "articles/2017-08-16-cant-tell-you-why/index.md"
			},
			"requirePath": "articles/2017-08-16-cant-tell-you-why/index.md",
			"path": "/cant-tell-you-why/",
			"data": {
				"title": "Can't Tell You Why",
				"date": "2017-05-11T19:16:07.169Z",
				"layout": "post",
				"path": "/cant-tell-you-why/",
				"category": "Poetry",
				"description": "Can't tell you why",
				"readNext": "/on-being-yourself/"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/2017-09-15-a-gentle-reminder",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/2017-09-15-a-gentle-reminder",
				"stem": "index",
				"path": "articles/2017-09-15-a-gentle-reminder/index.md"
			},
			"requirePath": "articles/2017-09-15-a-gentle-reminder/index.md",
			"path": "/a-gentle-reminder/",
			"data": {
				"title": "A Gentle Reminder",
				"date": "2017-09-15T19:16:07.169Z",
				"layout": "post",
				"path": "/a-gentle-reminder/",
				"category": "Poetry",
				"description": "A Gentle Reminder",
				"readNext": "/cant-tell-you-why/"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/2017-09-16-always",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/2017-09-16-always",
				"stem": "index",
				"path": "articles/2017-09-16-always/index.md"
			},
			"requirePath": "articles/2017-09-16-always/index.md",
			"path": "/always/",
			"data": {
				"title": "Always",
				"date": "2017-09-16T19:16:07.169Z",
				"layout": "post",
				"path": "/always/",
				"category": "Poetry",
				"description": "Always",
				"readNext": "/a-gentle-reminder/"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/2017-10-6-at-the-same-time",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/2017-10-6-at-the-same-time",
				"stem": "index",
				"path": "articles/2017-10-6-at-the-same-time/index.md"
			},
			"requirePath": "articles/2017-10-6-at-the-same-time/index.md",
			"path": "/at-the-same-time/",
			"data": {
				"title": "At The Same Time",
				"date": "2017-10-06T19:16:07.169Z",
				"layout": "post",
				"path": "/at-the-same-time/",
				"category": "Poetry",
				"description": "At The Same Time",
				"readNext": "/always/"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "index.jsx",
				"ext": "jsx",
				"name": "index",
				"extname": ".jsx",
				"basename": "index.jsx",
				"dirname": "",
				"stem": "index",
				"path": "index.jsx"
			},
			"requirePath": "index.jsx",
			"path": "/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "pages/blog",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "pages/blog",
				"stem": "index",
				"path": "pages/blog/index.md"
			},
			"requirePath": "pages/blog/index.md",
			"path": "/blog/",
			"data": {
				"title": "Blog",
				"layout": "blog",
				"path": "/blog"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "pages/colors",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "pages/colors",
				"stem": "index",
				"path": "pages/colors/index.md"
			},
			"requirePath": "pages/colors/index.md",
			"path": "/colors/",
			"data": {
				"title": "Colors",
				"layout": "colors",
				"path": "/colors"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "pages/contact",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "pages/contact",
				"stem": "index",
				"path": "pages/contact/index.md"
			},
			"requirePath": "pages/contact/index.md",
			"path": "/contact/",
			"data": {
				"title": "Contact",
				"layout": "page",
				"path": "/contact"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "pages/friends",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "pages/friends",
				"stem": "index",
				"path": "pages/friends/index.md"
			},
			"requirePath": "pages/friends/index.md",
			"path": "/friends/",
			"data": {
				"title": "A Few Friends",
				"layout": "page",
				"path": "/friends"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "pages/gaming",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "pages/gaming",
				"stem": "index",
				"path": "pages/gaming/index.md"
			},
			"requirePath": "pages/gaming/index.md",
			"path": "/gaming/",
			"data": {
				"title": "What I play",
				"layout": "page",
				"path": "/gaming"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "pages/now",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "pages/now",
				"stem": "index",
				"path": "pages/now/index.md"
			},
			"requirePath": "pages/now/index.md",
			"path": "/now/",
			"data": {
				"title": "What I'm doing now",
				"layout": "page",
				"path": "/now"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "pages/reading",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "pages/reading",
				"stem": "index",
				"path": "pages/reading/index.md"
			},
			"requirePath": "pages/reading/index.md",
			"path": "/reading/",
			"data": {
				"title": "What I've read",
				"layout": "page",
				"path": "/reading"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "pages/work",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "pages/work",
				"stem": "index",
				"path": "pages/work/index.md"
			},
			"requirePath": "pages/work/index.md",
			"path": "/work/",
			"data": {
				"title": "Work",
				"layout": "page",
				"path": "/work"
			}
		}
	]
}


//////////////////
// WEBPACK FOOTER
// ../config.toml
// module id = 385
// module chunks = 0